/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_SponsoringInputs */



/**
* | output |
* | --- |
* | "Sponsoring..." |
*
* @param {Vekn_SponsoringInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sponsoring = /** @type {((inputs?: Vekn_SponsoringInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_SponsoringInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parrainage...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Patrocinando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Patrocinando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sponsorizzazione...")
	return /** @type {LocalizedString} */ ("Sponsoring...")
});